import axios from 'axios';
import { AGENTS_ENDPOINTS } from '../config/api';

export const SET_CAMPAIGN = "SET_CAMPAIGN";
export const SET_CAMPAIGN_LOADING = "SET_CAMPAIGN_LOADING";
export const SET_VETTING_DATA = "SET_VETTING_DATA";
export const UPDATE_VETTING_DATA = "UPDATE_VETTING_DATA";
export const UPDATE_VETTING_USER = "UPDATE_VETTING_USER";
export const SET_POST_DRAFTS = "SET_POST_DRAFTS";
export const UPDATE_POST_DRAFT_ITEM = "UPDATE_POST_DRAFT_ITEM";

export const setCampaign = (campaign) => ({ type: SET_CAMPAIGN, payload: campaign });

export const getVettingUsers = (campaignId, offerId, params, showLoader) =>
  async dispatch => {
    const request = offerId
      ? axios(AGENTS_ENDPOINTS.OFFER.VETTING(offerId, params))
      : axios(AGENTS_ENDPOINTS.CAMPAIGN.VETTING(campaignId, params));
    dispatch(setVettingData({
      loading: showLoader
    }));

    return request
      .then(({ data }) => {
        const {
          vetting_users: vettingUsers,
          user_offer_object_attributes: userOfferObjectAttributes,
          filters,
          pagination,
          sort_options: sortOptions,
          hired_count: hiredCounter,
          backup_count: backupCounter,
          rejected_count: notSelectedCounter,
          pending_count: pendingCounter,
          total_count: totalCounter
        } = data;

        if (!vettingUsers) throw new Error;

        dispatch(setVettingData({
          hiredCounter,
          backupCounter,
          notSelectedCounter,
          pendingCounter,
          totalCounter,
          filters,
          sortOptions,
          pagination,
          vettingUsers,
          userOfferObjectAttributes,
          loading: false,
          error: false
        }));
      })
      .catch(() => {
        dispatch(setVettingData({
          error: true,
          loading: false,
          vettingUsers: []
        }));
      });
  };
export const updateVettingData = () => ({ type: UPDATE_VETTING_DATA });
export const setVettingData = (data) => ({ type: SET_VETTING_DATA, payload: data });
export const updateVettingUser = (userId, user, status) => ({
  type: UPDATE_VETTING_USER,
  payload: { userId, user, status }
});

export const setPostDrafts = (items) => ({ type: SET_POST_DRAFTS, payload: items });
export const updatePosDraftItem = (draftId, item) => ({
  type: UPDATE_POST_DRAFT_ITEM,
  payload: { draftId, item }
});

